const nl_messages = require('./nl/messages.json')

const NEDERLAND_STRINGS = {
  translation: nl_messages
}

export default NEDERLAND_STRINGS
